module.exports = __webpack_public_path__ + "img/word_bg.267ab817.png";